import React, { useMemo } from 'react';
import { CompanyQueryData } from '@area-restrita/api-client/model/companyQueryData';
import { useGetCompaniesInfinite } from '@area-restrita/api-client/endpoints/companies/companies.gen';

import Combobox, { ComboboxOption } from '@/components/Combobox';
import { cn } from '@/lib/utils';

const toComboboxOption = (company: CompanyQueryData): ComboboxOption => ({
  label: company.tradingName,
  value: company.id,
});

interface IProps {
  value?: ComboboxOption;
  onChange?: (option?: ComboboxOption) => void;
  className?: string;
}

const CompanySelector: React.FC<IProps> = ({ value, onChange, className }) => {
  const query = useGetCompaniesInfinite(
    { limit: 1000, page: 1 },
    {
      query: {
        queryKeyHashFn: (args) => JSON.stringify(['infinite', ...args]),
        getNextPageParam: (lastPage, _, lastPageParam) =>
          lastPage.data.length > 0 ? lastPageParam + 1 : null,
      },
    },
  );

  const companies = useMemo(
    () =>
      query.data?.pages.flatMap<ComboboxOption>((page) =>
        page.data.map(toComboboxOption),
      ) ?? [],
    [query.data],
  );

  return (
    <Combobox
      options={companies}
      onChangeValue={onChange}
      value={value}
      placeholder="Select company..."
      searchPlaceholder="Search company..."
      isLoading={query.isFetching}
      className={cn('w-full', className)}
    />
  );
};

export default CompanySelector;
